import { IApiService } from '../../services/ApiService';
import { redirect } from 'react-router';
import { authNavigationService } from '../../services/AuthNavigationService';

export function homePageLoader(apiService: IApiService) {
  return async () => {
    // HomePage is a protected route - verify user is authenticated
    // isAuthenticated() is synchronized at app startup via getUserDetail() in useAppInitialization
    if (!apiService.isAuthenticated()) {
      const redirectUrl = authNavigationService.getRedirectUrlFor401('/');
      if (redirectUrl) {
        return redirect(redirectUrl);
      }
    }

    // No data needed - HomePage doesn't use useLoaderData()
    return {};
  };
}
